<template>
  <div class="getVip">
    <div class="topbg">
      <img src="../assets/img/vipTop.png" alt="" />
    </div>
    <div class="content">
      <div class="title">助力好友赢会员</div>
      <div class="ipt-wapper">
        <input type="text" v-model="tel" placeholder="请输入手机号" />
      </div>
      <div class="detail">
        填写手机号并下载登录或登录后绑定好友邀请码，好友即可获得7天免费会员
      </div>
    </div>
    <div class="down">
      <div class="btn" @click="upLoad">立即下载</div>
    </div>
    <div class="logo-wapper">
      <div>
        <div class="img_wapper">
          <img src="../assets/img/logo.png" alt="" />
          <span>定位有术</span>
        </div>
        <div class="subtitle">实时定位查询，守护亲友安全</div>
      </div>
    </div>
    <div class="mask-loading" v-if="showMask" @click="showMask = false">
      <div id="">
        <img class="mask-arrow" src="../assets/img/weixinh5_arrow.png" />
      </div>
      <img class="mask-text" src="../assets/img/weixinh5_main.png" />
    </div>
  </div>
</template>

<script>
import { isWeChatDevTools } from "../utils/env";
export default {
  data() {
    return {
      showMask: false,
      inviteCode: this.$route.query.coinnum || "",
      tel : ""
    };
  },
  created() {
    if (!isWeChatDevTools) this.getAppApkVersion();
  },
  methods: {
    async getAppApkVersion() {
      let res = await this.$api.getAppApkVersion();
      let data = res.data;
      window.apkUrl = data;
    },
    async upLoad() {
      if (isWeChatDevTools) return (this.showMask = true);
      if (this.tel == "") {
        return (window.location.href = window.apkUrl.image_url);
      }

      if (!/^1\d{10}$/.test(this.tel)) {
        return this.$toast("手机号码填写错误，请重新填写");
      }
      try {
        let res = await this.$api.setShare({
          phone: this.tel,
          invite_code: this.inviteCode,
        });
      } catch (error) {}
      return (window.location.href = window.apkUrl.image_url);
    },
  },
};
</script>

<style lang="less">
html,
body,
#app {
  height: 100%;
}
.getVip {
  background-color: #f4f6f8;
  height: 100%;
  overflow-y: auto;
  font-size: 0;
  .topbg {
    img {
      width: 100%;
      max-height: 56vh;
    }
  }
  .content {
    padding: 6.667vw;
    border-radius: 5.6vw;
    background: #fff;
    margin: -22% 4.4vw 0;
    position: relative; //加这条样式
    .title {
      color: #1a213c;
      font-size: 4.4vw;
      text-align: center;
      font-weight: 600;
    }
    .ipt-wapper {
      text-align: center;
    }
    input {
      outline: none;
      margin-top: 6.667vw;
      border-radius: 50px;
      background: #f4f6f8;
      padding: 3.333vw 6.4vw;
      color: #41474d;
      font-size: 3.867vw;
      &::-webkit-input-placeholder {
        color: #a6b2bf;
      }
    }
    .detail {
      margin-top: 4.4vw;
      color: #a6b2bf;
      font-size: 3.867vw;
      line-height: 6.133vw;
    }
  }
  .down {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 6.667vw;
    .btn {
      display: flex;
      width: 61.067vw;
      height: 12.267vw;
      background: #34dda5;
      border-radius: 7.467vw;
      color: #fff;
      font-size: 4.4vw;
      align-items: center;
      justify-content: center;
    }
  }
  .logo-wapper {
    margin-top: 10.667vw;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 0.667vw;
    .img_wapper {
      font-size: 3.867vw;
      color: #191e34;
      display: flex;
      align-items: center;
      img {
        width: 10vw;
        height: 10vw;
        margin-right: 1.733vw;
      }
    }
    .subtitle {
      color: #a6b2bf;
      font-size: 2.8vw;
      margin-top: 1.733vw;
    }
  }

  .mask-loading {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    text-align: center;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 99999;
  }
  .mask-loading > div {
    text-align: right;
  }
  .mask-loading .mask-arrow {
    padding-top: 20px;
    width: 18%;
    margin-right: 5%;
  }
  .mask-loading .mask-text {
    width: 80%;
    margin-top: -7px;
  }
}
</style>